import managed from '@/store/modules/managed'

const module = managed('submits/bundles')

export default module
